module.exports = __webpack_public_path__ + "img/parrallel_3.c0529927.png";